import { AuthContext as e } from "../context/AuthContext.mjs";
import { useAuthStateQuery as t } from "../queries/state/useAuthStateQuery.mjs";
import { useEffect as n, useMemo as r, useRef as i } from "react";
import { jsx as a } from "react/jsx-runtime";
import { setSessionProbe as o } from "@maat/api-base";
//#region src/provider/AuthProvider.tsx
var s = ({ children: s }) => {
	let { data: c } = t(), l = i(c.isAuthenticated);
	l.current = c.isAuthenticated, n(() => (o(() => l.current), () => o(void 0)), []);
	let u = r(() => ({
		isAuthenticated: c.isAuthenticated,
		hasHostProfile: c.isAuthenticated ? c.has_host_profile : !1,
		identityVerified: c.isAuthenticated ? c.identity_verified : !1,
		profileCompleted: c.isAuthenticated ? c.profile_completed : !1,
		activeProfile: c.isAuthenticated ? c.active_profile : "guest",
		activeWorkspaceId: c.isAuthenticated ? c.active_workspace_id : null,
		preferredCurrency: c.preferred_currency || "USD",
		permissions: c.isAuthenticated ? c.permissions ?? [] : [],
		impersonator: c.isAuthenticated ? c.impersonator ?? null : null,
		impersonationAccess: c.isAuthenticated ? c.impersonation_access ?? null : null,
		isCreatorPartner: c.isAuthenticated ? c.is_creator_partner ?? !1 : !1
	}), [c]);
	return /* @__PURE__ */ a(e.Provider, {
		value: u,
		children: s
	});
};
//#endregion
export { s as AuthProvider };
